const messages = {
  en: {
    translations: {
      ticketChipRail: {
        moreOne: "1 more tag",
        moreMany: "{{count}} more tags",
        kanbanStep: "Kanban stage",
        noQueue: "No queue",
        group: "Group",
        groupMember: "{{count}} member",
        groupMember_plural: "{{count}} members",
        groupTooltip: "WhatsApp group",
        groupShared: "Group shared across {{count}} connections",
        tabTooltip: "Tab: {{name}}",
      },
      ticketRowActions: {
        menu: "Ticket actions",
        transfer: "Transfer",
        close: "Close ticket",
        ignore: "Ignore",
        reopen: "Reopen",
        mute: "Mute group",
        unmute: "Unmute group",
        muted: "Group muted",
      },
      crossConnection: {
        chipPrefix: "Being served",
        days7: "7 days",
        connectionsCount: "{{count}} connections",
        unknownAttendant: "Another agent",
        unknownConnection: "another connection",
        isServingOn: "is serving this customer on connection",
        since: "since",
        modalTitle: "Customer already being served",
        modalHint: "Check before replying to avoid duplicating the order.",
        acceptAnyway: "Accept anyway",
        openOther: "Open conversation of",
        viewOther: "View conversation",
        cancel: "Cancel",
        notifyCalledAlsoOn: "also reached out on connection",
        notifyFallbackContact: "Your customer",
        bannerTitle: "Customer being served on another connection",
        onConnection: "on connection",
        startedAt: "since",
        chipAria: "Customer being served on another connection",
        lastClosedChip: "Served",
        lastClosedTitle: "Last service on another connection",
        closedWord: "closed",
        agoMinutes: "{{count}} min ago",
        agoHours: "{{count}} h ago",
        agoDays: "{{count}} days ago",
        agoOneDay: "1 day ago",
        agoNow: "just now",
        reasonLabel: "Reason",
        demandLabel: "Type",
        showMore: "show more",
        showLess: "show less",
      },
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        title: "Dashboard",
        loadingMessage: "Dashboard data will be loaded shortly...",
        refreshing: "Updating data...",
        pleaseWait: "Please wait",
        hero: {
          inService: "In Service",
          ticketsNow: "tickets now",
          pending: "Pending",
          waitingService: "waiting for service",
          criticalTooltip: "Tickets waiting for more than 30 minutes",
          critical: "critical",
          avgWaitTime: "Avg Wait Time",
          avgWaitLabel: "average wait time",
          maxWait: "Longest wait",
          nps: "NPS Score",
          promoters: "Promoters",
          passives: "Passives",
          detractors: "Detractors",
        },
        sections: {
          operational: "Operational Overview",
          deepAnalysis: "Detailed Analysis",
          aiIntelligence: "Intelligence & AI",
        },
        loading: "Loading...",
        refresh: "Refresh data",
        kpis: {
          resolutionRate: "Resolution",
          resolved: "resolved",
          abandonmentRate: "Abandonment",
          leftQueue: "left the queue",
          slaFirstResponse: "SLA 1st Resp.",
          under5min: "< 5 min",
          reopened: "Reopened",
          ticketsReopened: "tickets reopened",
          finished: "Finished",
          closedPeriod: "in period",
          demand: "Demand",
          activeDemand: "Company initiated",
          passiveDemand: "Customer initiated",
          activeVsPassive: "active vs passive",
        },
        health: {
          title: "Service Health",
          excellent: "Excellent",
          attention: "Attention",
          critical: "Critical",
          basedOn: "Based on",
          indicators: "indicators",
          pendingQueue: "Pending in queue",
          avgWaitTime: "Avg wait time",
          slaCompliance: "SLA compliance",
          abandonRate: "Abandon rate",
          npsScore: "NPS Score",
        },
        heatmap: {
          title: "Weekly Heat Map",
          less: "Less",
          more: "More",
          peak: "Peak",
          total: "Total",
          avgPerDay: "Avg/day",
          peakSlot: "Peak (2h)",
          days: {
            dom: "Sun",
            seg: "Mon",
            ter: "Tue",
            qua: "Wed",
            qui: "Thu",
            sex: "Fri",
            sab: "Sat",
          },
        },
        demand: {
          title: "Ticket Origin",
          companyInitiated: "Company initiated",
          clientInitiated: "Customer initiated",
        },
        ai: {
          title: "Autonomous AI",
          noData: "No autonomous AI data for this period",
          totalInteractions: "Interactions",
          tokensUsed: "Tokens used",
          estimatedCost: "Est. cost",
          handoffRate: "Handoff rate",
          avgConfidence: "Avg confidence",
          handoffReasons: "Handoff reasons",
          noHandoffs: "No handoffs in this period",
          reasons: {
            respond: "Responded",
            handoff: "Handoff",
            ignore: "Ignored",
            clarify: "Clarify",
            escalate: "Escalate",
          },
        },
        queues: {
          title: "Real-Time Queues",
          noData: "No queue data available",
          pending: "Pending",
          inProgress: "In progress",
          onlineAgents: "Online agents",
          moreQueues: "more queues",
          totalPending: "Pending",
          totalInProgress: "In progress",
          totalOnline: "Online",
        },
        sentiment: {
          title: "Sentiment",
          noData: "No sentiment data for this period",
          positive: "Positive",
          neutral: "Neutral",
          negative: "Negative",
          frustrated: "Frustrated",
          score: "Satisfaction",
          satisfaction: "Score",
          total: "total",
        },
        leads: {
          title: "Leads Funnel",
          noData: "No leads data for this period",
          newContacts: "New Contacts",
          qualified: "Qualified",
          negotiation: "In Negotiation",
          converted: "Converted",
          conversionRate: "Conversion rate",
          totalLeads: "Total leads",
          avgTicketValue: "Avg ticket value",
          totalValue: "Total value",
        },
        campaigns: {
          title: "Campaigns",
          noData: "No campaigns in this period",
          sent: "Sent",
          delivered: "Delivered",
          read: "Read",
          failedCount: "Failed",
          deliveryRate: "Delivery rate",
          active: "Active",
          recent: "Recent",
          completed: "Completed",
          running: "Running",
          scheduled: "Scheduled",
          failed: "Failed",
          paused: "Paused",
        },
        voice: {
          title: "Voice AI",
          noData: "No call data for this period",
          totalCalls: "Calls",
          resolutionRate: "Resolution",
          avgDuration: "Avg duration",
          cost: "Est. cost",
          outcomes: "Outcomes",
          resolved: "Resolved",
          transferred: "Transferred",
          voicemail: "Voicemail",
          dropped: "Dropped",
          noAnswer: "No answer",
          dailyCalls: "Daily calls",
        },
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
          messages: "Messages",
          ticketFlow: "Ticket Flow",
          opened: "Opened",
          closed: "Closed",
          noData: "No data for the selected period",
          attendantRanking: "Attendant Ranking",
          attendants: "attendants",
          noAttendants: "No attendants found",
          name: "Name",
          tickets: "Tickets",
          avgWait: "AWT",
          avgSupport: "AST",
          rating: "Rating",
          channelDist: "Channel Distribution",
          totalTickets: "tickets",
          hourlyActivity: "Hourly Activity",
          peakHour: "Peak",
          pendingByQueue: "Pending by Queue",
          pending: "Pending",
          total: "total",
          noPending: "No pending tickets",
          topContacts: "Top Contacts",
          noContacts: "No contacts found",
          avgServiceTime: "Avg time",
          timeMetrics: "Time Metrics",
          avgWaitTime: "AWT",
          avgSupportTime: "AST",
          firstResponse: "1st Response",
          time: "Time (min)",
          statusDist: "Status Distribution",
          channelTrend: "Channel Trend",
          forecast: "Forecast",
        },
        messageVolume: {
          title: "Message Volume",
          tooltip: "Total messages sent, received, and delivery failures per day",
          sent: "Sent",
          received: "Received",
          failed: "Failed",
          failureRate: "Rate",
          failureRateTooltip: "Percentage of messages that failed out of total sent",
          topErrors: "Top delivery errors",
          noData: "No message data for the period",
        },
        general: {
          title: "General Information",
        },
        overview: {
          title: "Overview and Ratings",
        },
        activity: {
          title: "Activity by Period and Performance",
          daily: "Daily Activity",
          perHour: "Hourly Activity",
        },
        distribution: {
          title: "Distribution by Channel and Queue",
          byChannel: "Distribution by Channel",
          byQueue: "Distribution by Queue",
          channels: "channels",
          queues: "queues",
        },
        hourly: {
          title: "Hourly Activity",
          peak: "Peak",
          between: "Between",
          and: "and",
        },
        tabs: {
          indicators: "Indicators",
          assessments: "NPS",
          attendants: "Attendants",
          weeklyOverview: "Weekly Overview",
        },
        total: "Total",
        noData: "No data available",
        cards: {
          inAttendance: "In Service",
          waiting: "Waiting",
          activeAttendants: "Active Attendants",
          finalized: "Completed",
          newContacts: "New Contacts",
          totalReceivedMessages: "Messages Received",
          totalSentMessages: "Messages Sent",
          averageServiceTime: "Service Time",
          averageWaitingTime: "Wait Time",
          status: "Status (Current)",
          activeTickets: "Active Tickets",
          passiveTickets: "Passive Tickets",
          groups: "Groups",
          totalTickets: "Total Tickets",
          avgWaitTimeNow: "Current AWT",
          maxWaitTimeNow: "Longest Wait",
          criticalPending: "Critical Pending",
          abandonmentRate: "Abandonment Rate",
          firstResponseSLA: "SLA 1st Response",
        },
        avgWaitTimeNowTooltip: "Average wait time of currently pending tickets",
        maxWaitTimeNowTooltip: "Wait time of the oldest ticket in queue",
        criticalPendingTooltip: "Tickets waiting for more than 30 minutes",
        abandonmentRateTooltip: "Tickets closed before being served",
        firstResponseSLATooltip: "Percentage of tickets served within 5 minutes",
        pendingNow: "Pending now",
        bottleneck: "Current bottleneck",
        over30min: "> 30 min wait",
        closedBeforeService: "Closed without service",
        under5min: "Served in < 5 min",
        pendingByQueue: {
          sectionTitle: "Pending by Queue Monitoring",
          title: "Pending by Queue",
          pending: "Pending",
          total: "pending",
          totalTooltip: "Total tickets awaiting service",
          ok: "< 15 min",
          alert: "15-30 min",
          critical: "> 30 min",
          empty: "No pending tickets",
          emptySubtext: "All queues are up to date!",
          avgWait: "Avg wait",
        },
        noQueue: "No queue",
        users: {
          name: "Name",
          numberAppointments: "Number of Tickets",
          statusNow: "Current",
          totalCallsUser: "Total tickets per user",
          totalAttendances: "Total tickets",
        },
        date: {
          initialDate: "Start Date",
          finalDate: "End Date",
        },
        filters: {
          title: "Filters",
          apply: "Filter",
          reset: "Clear Filters",
          quickFilters: "Quick Filters",
          customRange: "Custom Period",
          allTime: "All Time",
          today: "Today",
          yesterday: "Yesterday",
          last7days: "Last 7 days",
          thisWeek: "This week",
          thisMonth: "This month",
          lastMonth: "Last month",
          sections: "Section Visibility",
          refreshInterval: "Refresh interval:",
          refreshManual: "Manual",
          refresh5min: "5 minutes",
          refresh15min: "15 minutes",
          refresh30min: "30 minutes",
          until: "to",
          hideSection: "Hide section",
          showAll: "Show All",
          hideAll: "Hide All",
          queuePlaceholder: "Filter by queue",
          noQueues: "No queues",
          userPlaceholder: "Filter by attendant",
          noUsers: "No attendants",
          connectionPlaceholder: "Filter by connection",
          noConnections: "No connections",
        },
        assessments: {
          totalCalls: "Total Tickets",
          callsWaitRating: "Tickets awaiting rating",
          callsWithoutRating: "Tickets without rating",
          ratedCalls: "Rated tickets",
          evaluationIndex: "Rating index",
          score: "Score",
          prosecutors: "Promoters",
          neutral: "Neutral",
          detractors: "Detractors",
          ratingTooltip: "of rated tickets",
        },
        tickets: {
          overview: "Ticket Status",
          timeline: "Service Timeline",
          created: "Tickets Created",
          active: "Currently active tickets",
          pending: "Tickets awaiting service",
          completed: "Completed services",
          demandActive: "Active demand",
          demandPassive: "Passive demand",
          inAttendanceTooltip: "Tickets currently being served",
          waitingTooltip: "Tickets not yet assigned to an attendant",
          finalizedTooltip: "Tickets that have been closed and resolved",
          activeTicketsTooltip: "Tickets initiated by the company",
          passiveTicketsTooltip: "Tickets initiated by the customer",
        },
        messages: {
          title: "Messages by Period",
          received: "Received",
          sent: "Sent",
          total: "Total",
          ratio: "Ratio",
        },
        attendants: {
          performance: "Attendant Ranking",
          online: "Online now",
        },
        topContacts: {
          title: "Contact Ranking",
          columns: {
            contact: "Contact",
            tickets: "Tickets",
            queue: "Queue",
            time: "Time",
          },
          noData: "No contacts to display",
          tooltip: "Top 10 contacts with most open tickets in the period",
          openTicket: "Open ticket",
          statusOpen: "Open",
          statusPending: "Pending",
          statusClosed: "Closed",
        },
        actions: {
          filter: "Filter",
          refresh: "Refresh",
          fullscreen: "Fullscreen",
          exitFullscreen: "Exit fullscreen",
        },
        online: "Online now",
        serviceTime: "Average service time",
        waitingTime: "Average queue wait time",
        newContacts: "New contacts in the period",
        fromLastMonth: "since last month",
        newContactsTooltip: "New contacts registered in the selected period",
        activeAttendantsTooltip: "Number of attendants available online",
        timeMetrics: "Time Metrics",
        firstResponseTooltip: "Average time to first attendant response",
        resolutionRateTooltip: "Percentage of resolved tickets relative to total",
        reopenedTicketsTooltip: "Tickets reopened after closure",
        avgTicketsPerDayTooltip: "Daily average of tickets in the period",
        firstResponseTime: "First Response",
        sort: {
          ascending: "Ascending",
          descending: "Descending",
          orderBy: "Sort by",
          tickets: "Number of Tickets",
          rating: "Rating",
          waitTime: "Wait Time",
          serviceTime: "Service Time",
        },
        status: {
          open: "Open",
          pending: "Pending",
          closed: "Closed",
          nps: "Rating",
        },
        export: {
          pdf: "Export PDF",
        },
        sla: {
          detailTitle: "SLA 1st Response Detail",
          under1min: "< 1 min",
          "1to5min": "1-5 min",
          "5to15min": "5-15 min",
          "15to30min": "15-30 min",
          over30min: "> 30 min",
          totalResponses: "Total responses",
          under5min: "Responded < 5 min",
          noData: "No SLA data for the period",
        },
        goals: {
          target: "Target",
        },
        alerts: {
          highWaitTime: "Current AWT above 10 minutes ({{value}} min)",
          criticalPending: "{{count}} critical tickets without response",
          highAbandonment: "High abandonment rate: {{rate}}%",
          npsDrop: "NPS dropped {{delta}} points from previous period",
        },
        callbacks: {
          title: "Returns & Transfers",
          noData: "No reopens or transfers in the period",
          reopened: "Reopened",
          transfers: "Transfers",
          uniqueReopened: "Reopened Tickets",
        },
        aiInsights: {
          title: "AI Insights",
          generate: "Generate Insights",
          generating: "Generating insights...",
          empty: "Click to generate insights about your data",
          error: "Error generating insights",
        },
        geo: {
          title: "Geographic Distribution",
          noData: "No geographic data for the period",
          totalStates: "States",
          totalTickets: "Total Tickets",
        },
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
          resolvePasskey: "Resolve authentication",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
        status: {
          connected: "Online",
          disconnected: "Offline",
          opening: "Opening",
          qrcode: "QR",
          timeout: "Timeout",
          pairing: "Pairing",
          passkeyRequired: "Passkey required",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
        errorGreetingMessage:
          "Greeting message is required when two or more queues are selected.",
        queueRequired: "A queue must be selected for message import.",
        vacationDatesRequired:
          "Start and end dates for collective vacation are required when vacation message is filled.",
        invalidDates:
          "Start date cannot be later than the end date for collective vacation.",
        errorExpiresInactiveMessage:
          "Inactivity closure message is required when ticket expiration time is configured.",
        errorTimeInactiveMessage:
          "Time for inactivity warning is required when inactivity message is filled.",
        npsDisabled:
          "NPS is disabled in company settings. Configure at: Settings > Company",
        queueSelected: "Queues selected. Prompt and Integrations are disabled.",
        promptSelected:
          "Prompt selected. Queues and Integrations are disabled.",
        integrationSelected:
          "Integration selected. Queues and Prompt are disabled.",
        importInfo:
          "The connection will be restarted to import messages. Please wait for the reconnection and import process.",
        status: {
          connected: "Connected",
          opening: "Opening",
          qrcode: "QR",
          disconnected: "Disconnected",
          timeout: "Timeout",
          pairing: "Pairing",
          destroyed: "Destroyed",
        },
      },
      qrCode: {
        message: "Read QrCode to start the session",
        passkey: {
          modalTitle: "Resolve passkey",
          title: "Passkey authentication required",
          detecting: "Detecting the extension...",
          connectingTitle: "Connecting...",
          connecting: "Session sent. Waiting for WhatsApp to connect...",
          ready: {
            description:
              "This connection needs a new WhatsApp authentication. Click below to resolve it securely through the browser extension.",
          },
          install: {
            title: "Install the extension to continue",
            description:
              "Resolving the passkey is done through a browser extension. Install it and reload this page.",
            step1: "Download the extension (.crx file or unpacked folder).",
            step2: "Open chrome://extensions and enable Developer mode.",
            step3: "Click 'Load unpacked' and select the extension folder.",
            step4: "Reload this page to detect the extension.",
          },
          existingSession: {
            title: "Another account is already connected",
            message: "There is already an account connected in this browser:",
            unknownNumber: "another account",
            question: "Do you want to disconnect it and continue?",
          },
          buttons: {
            resolve: "Resolve authentication",
            retry: "Try again",
            cancel: "Cancel",
            clearAndContinue: "Disconnect and continue",
            migrateToWaba: "Migrate to official WABA",
          },
          errors: {
            noUrl: "Could not get the import URL. Please try again.",
            generic: "Failed to import the session. Please try again.",
            withReason: "Failed to import the session: {{reason}}",
          },
          connectionFailed: {
            title: "Could not connect",
            description:
              "The session was imported, but the WhatsApp connection failed. Please try again.",
            withReason: "Could not connect: {{reason}}",
            timeoutTitle: "Could not connect — timed out",
            timeoutDescription:
              "The session was imported, but we did not receive connection confirmation in time. Please try again.",
          },
        },
      },
      schedules: {
        title: "Schedules",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this schedule?",
          deleteMessage: "This action cannot be undone.",
          deleteSeriesTitle: "Cancel the whole series?",
          deleteSeriesMessage:
            "This cancels the whole series ({{remaining}} pending sends for {{contact}}), not just this day. Sends already made are not undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Scheduled at",
          sentAt: "Sent at",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New schedule",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
        calendar: {
          indicatorPending: "{{sent}}/{{total}} sent · next {{next}}",
          indicatorDone: "{{sent}}/{{total}} sent",
          indicatorError: "{{sent}}/{{total}} · failed {{next}}",
          indicatorTruncated: "showing {{emitted}} of {{logicalTotal}}",
          loadMore: "Load more",
          showingCount: "Showing {{loaded}} of {{total}}",
          emptyLoadedRange: "No occurrences of the loaded series in this period.",
          partialRange: "Partial display for this period — switch to week or day view to see every occurrence.",
        },
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        errors: {
          numberWithDDI:
            "Include the country code. Use 55 for Brazil (e.g., 5511999999999) or the appropriate code (e.g., +12125551234)",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
          none: "None",
          integrationId: "Integration",
          flowId: "FlowBuilder",
          flowPriorityHelp: "FlowBuilder and Integration are mutually exclusive: configure only one of them on the queue. To switch, clear the selected one first.",
          flowIntegrationConflict: "The queue cannot be saved with both FlowBuilder and Integration set. Remove one of them.",
          fileListId: "File list",
          closeTicket: "Close ticket",
          distributionStrategy: {
            random: "Random distribution",
            round_robin: "Sequential round-robin",
            least_load: "Least load",
            label: "Distribution strategy",
          },
          rotateHelp: {
            title: "How distribution works",
            content: "When enabled, the system picks an online agent who is not paused for each new ticket. Random draws one; sequential round-robin hands one ticket to each available agent, roughly in the same order; least load picks whoever has fewer open and pending tickets. The ticket stays pending until the agent accepts it. The time sets how soon an unaccepted ticket moves to another agent. Each person's simultaneous-ticket limit is set on the user record.",
          },
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          signatureName: "Signature name",
          signatureNameHelper:
            "Name shown when signing messages. Empty = full name.",
          email: "Email",
          password: "Password",
          profile: "Profile",
          seeAllGroups: "See all groups",
          seeAllGroupsHelp: "On: sees every group of the connections they can reach, including new ones.",
          groupAccess: "Groups this user can see",
          groupAccessPlaceholder: "Search group",
          groupAccessEmpty: "No group selected: this user will not see groups.",
          groupAccessHidden: "{{count}} group(s) from connections outside the current reach remain saved.",
          maxConcurrentTickets: "Maximum simultaneous tickets",
          maxConcurrentTicketsHelp:
            "Used by queue distribution: counts open and pending tickets across every queue. Empty or 0 means no limit.",
          maxConcurrentTicketsInvalid: "Enter a whole number from 0 to 1000.",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      chatInternal: {
        title: "Internal Chat",
        new: "New",
        selectChat: "Select a chat to start",
        emptyState: "Select a conversation to start",
        buttons: {
          new: "New",
        },
        participants: "participant",
        participantsPlural: "participants",
        messagePlaceholder: "Type a message...",
        modal: {
          conversation: "Start",
          title: "Title",
          createTitle: "Create New Room",
          editTitle: "Edit Room",
          iconColor: "Icon Color",
          filterUsers: "Select Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Chat",
          message: "This action cannot be reverted, confirm?",
        },
        options: {
          sticker: "Sticker",
          voiceMessage: "Voice message",
          poll: "Poll",
          location: "Location",
        },
        messages: {
          deleted: "Message deleted",
          deletedVisible: "Deleted",
          edited: "edited",
        },
        contextMenu: {
          reply: "Reply",
          react: "React",
          edit: "Edit",
          delete: "Delete",
        },
        editDialog: {
          title: "Edit Message",
          placeholder: "Type the new message...",
          original: "Original",
          cancel: "Cancel",
          save: "Save",
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        showAll: {
          lockedByTeam: "Enabled by team membership — teammates' tickets must be visible for team notifications",
        },
        toasts: {
          deleted: "The ticket you were on has been deleted.",
          redirectedToExisting: "There is already an open ticket for this contact. You have been redirected.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        noQueueBadge: "{{count}} without queue",
        noQueueTooltip: "Tickets waiting without any queue. Nobody on the team can see them. Configure a redirect queue on the connection or take them over manually.",
        noQueueFilterOn: "Showing only tickets without a queue — click to see all",
        noLastMessage: "No preview",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          queues: "Queues",
          tasks: "Tasks",
          automations: "Automations",
          journey: "Journey",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
          profilePermissions: "Profile Permissions",
          aiTools: "AI Integrations",
          moments: "Moments",
          stalledTickets: "Stalled conversations",
          whatsappCommunities: "Communities",
          whatsappFlows: "WhatsApp Flows",
          email: "Email",
          contactsImport: "Import contacts",
          helpCenter: "Help Center",
          internalChat: "Internal chat",
          todo: "To-do",
          tagsKanban: "Kanban columns",
          reportsAdvanced: "Advanced reports",
          financeiro: "Billing",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      common: {
        cancel: "Cancel",
        next: "Next",
        back: "Back",
        save: "Save",
        saving: "Saving...",
        close: "Close",
        confirm: "Confirm",
        delete: "Delete",
        edit: "Edit",
        add: "Add",
        search: "Search",
        loading: "Loading...",
        yes: "Yes",
        no: "No",
        ok: "OK",
      },
      aiTools: {
        title: "AI Integrations",
        steps: {
          connector: "Connector",
          endpoint: "Endpoint",
          parameters: "Parameters",
          response: "Response",
          access: "Access",
        },
        table: {
          name: "Name",
          endpoint: "Endpoint",
          category: "Category",
          stats: "Statistics",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Integration",
          refresh: "Refresh",
          createFirst: "Create first integration",
        },
        filters: {
          search: "Search by name...",
          category: "Category",
          status: "Status",
          all: "All",
          active: "Active",
          inactive: "Inactive",
        },
        status: {
          active: "Active",
          inactive: "Inactive",
        },
        actions: {
          test: "Test",
          logs: "View logs",
          edit: "Edit",
          delete: "Delete",
        },
        stats: {
          executions: "executions",
        },
        empty: {
          noTools: "No integrations configured",
          noResults: "No results found",
          description: "Configure integrations so the AI can interact with external systems.",
        },
        confirmDelete: {
          title: "Delete Integration",
          message: "Are you sure you want to delete the integration '{{name}}'?",
        },
        messages: {
          createSuccess: "Integration created successfully!",
          updateSuccess: "Integration updated successfully!",
          deleteSuccess: "Integration deleted successfully!",
          activated: "Integration activated!",
          deactivated: "Integration deactivated!",
        },
        modal: {
          titleCreate: "New Integration",
          titleEdit: "Edit Integration",
          selectConnector: "Select a connector",
          selectTemplate: "Select a template",
          configureEndpoint: "Configure endpoint",
          authentication: "Authentication",
          configureParameters: "Configure parameters",
          parametersDescription: "Define the parameters that the AI can pass to this integration.",
          configureResponse: "Configure response",
          configureAccess: "Access control",
        },
        fields: {
          name: "Technical name",
          nameHelp: "Used internally (e.g., create_ticket)",
          displayName: "Display name",
          description: "Description",
          descriptionHelp: "Describe what this integration does so the AI understands when to use it.",
          baseUrl: "Base URL",
          path: "Path",
          method: "HTTP Method",
          username: "Username",
          password: "Password",
          headerName: "Header Name",
          successPath: "Success JSONPath",
          successTemplate: "Success template",
          templateHelp: "Use {{result}} to insert the extracted value",
          jsonPathHelp: "E.g.: $.data.id or $.response.ticket_id",
          errorPath: "Error JSONPath",
          errorTemplate: "Error template",
          isActive: "Integration active",
          allowedQueues: "Allowed queues",
          allowedQueuesPlaceholder: "Select queues...",
          allowedQueuesHelp: "Leave empty to allow in all queues",
          allowedAgents: "Allowed AI agents",
          allowedAgentsPlaceholder: "Select agents...",
          allowedAgentsHelp: "Leave empty to allow in all agents",
          allowedContactNumbers: "Authorized phone numbers (whitelist)",
          allowedContactNumbersHelp: "Leave empty to allow any contact. When filled, only these numbers can execute this tool.",
          allowedContactNumbersWarning: "Warning: only {{count}} authorized number(s) can execute this tool. Unauthorized contacts will receive an access denied message.",
        },
        parameters: {
          name: "Name",
          type: "Type",
          description: "Description",
          required: "Required",
          expand: "Advanced options",
          remove: "Remove",
          add: "Add parameter",
          addFirst: "Add first parameter",
          empty: "No parameters defined. The AI won't be able to pass data to this integration.",
          advanced: "Advanced options",
          default: "Default value",
          minLength: "Min. characters",
          maxLength: "Max. characters",
          min: "Minimum value",
          max: "Maximum value",
          enumValues: "Allowed values",
          addEnumValue: "Add value",
        },
        test: {
          title: "Test Integration",
          parameters: "Test parameters",
          noParameters: "This integration requires no parameters.",
          dryRun: "Simulation mode (dry run)",
          dryRunDescription: "Does not execute the real call, only validates parameters.",
          dryRunWarning: "Simulation mode active. The real call will not be executed.",
          execute: "Run test",
          testing: "Testing...",
          result: "Result",
          rawResponse: "Full response",
          request: "Request that would be sent",
        },
        logs: {
          title: "Execution Logs",
          totalExecutions: "Total executions",
          successRate: "Success rate",
          avgLatency: "Average latency",
          errors: "Errors",
          status: "Status",
          startDate: "Start date",
          endDate: "End date",
          date: "Date",
          latency: "Latency",
          ticket: "Ticket",
          httpStatus: "HTTP",
          input: "Input",
          output: "Output",
          error: "Error",
          noLogs: "No execution logs found.",
        },
        connectorHelp: {
          title: "Configuration Help",
          showHelp: "View documentation",
          hideHelp: "Hide documentation",
          viewFullDocs: "View full documentation",
          authSection: "Authentication",
          fieldsSection: "Fields",
          ixc: {
            title: "IXC Provider (ERP)",
            description: "Integration with IXC Soft system for internet providers.",
            requirements: "Requirements",
            authHelp: "Use Basic Auth with token in 'ID:TOKEN' format",
            fieldsHelp: "Required fields: id_ticket_setor, titulo, menssagem",
          },
          milvus: {
            title: "Milvus Help Desk",
            description: "Integration with Milvus system for support ticket management.",
            requirements: "Requirements",
            authHelp: "Use Bearer Token with API token generated in Milvus panel",
            fieldsHelp: "Required fields: titulo, descricao, categoria_id",
          },
          zendesk: {
            title: "Zendesk Support",
            description: "Integration with Zendesk for support ticket management.",
            requirements: "Requirements",
            authHelp: "Use Basic Auth with email/token or Bearer Token",
            fieldsHelp: "Required fields: subject, description, requester",
          },
          triatox: {
            title: "Triatox Laboratory",
            description: "Integration with Triatox system for laboratories.",
            requirements: "Requirements",
            authHelp: "Use credentials provided by Triatox support",
            fieldsHelp: "Check specific Triatox documentation",
          },
          generic: {
            title: "Generic REST API",
            description: "Configure any REST API. Ideal for custom integrations.",
            requirements: "Requirements",
            authHelp: "Choose auth type: Bearer, Basic, API Key or custom Header",
            fieldsHelp: "Configure parameters according to API documentation",
          },
          custom: {
            title: "Manual Configuration",
            description: "Configure all details manually, without predefined template.",
            requirements: "Requirements",
            authHelp: "Configure authentication according to API documentation",
            fieldsHelp: "Define all required parameters manually",
          },
        },
        responsePresets: {
          title: "Mapping Presets",
          description: "Select a preset or configure manually",
          custom: "Custom",
          standard: "Standard ($.data.id)",
          ixcTicket: "IXC - Ticket ($.id)",
          milvusTicket: "Milvus - Ticket ($.chamado.id)",
          zendeskTicket: "Zendesk - Ticket ($.ticket.id)",
          restApi: "REST API ($.result)",
        },
        quickSetup: {
          title: "Quick Setup",
          credentialsStep: "Credentials",
          autoConfigured: "✨ Auto-configured! The endpoint, parameters and mappings have been filled in. You just need to enter your credentials.",
          action: "Action",
          endpoint: "Endpoint",
          parameters: "AI Parameters",
          moreParams: "more",
          credentials: "Your Credentials",
          urlHelp: "API base URL (pre-filled, change only if needed)",
          tokenLabel: "API Token / Access Key",
          tokenPlaceholder: "Paste your API token here",
          tokenHelp: "Authentication token obtained from the system panel",
          advancedSettings: "Advanced Settings",
        },
        transferTargets: {
          title: "Destination queues",
          help: "The AI picks one of these destinations by name. Describe when to use each one; the text goes into the tool instructions.",
          queue: "Queue",
          label: "Name for the AI",
          labelHelp: "Empty = queue name. Use the same name as in your prompt (e.g.: Test Results).",
          whenToUse: "When to use",
          whenToUsePlaceholder: "E.g.: patient wants to send test results",
          add: "Add queue",
          remove: "Remove",
          required: "Choose at least one destination queue.",
          queueRequired: "Choose the queue",
          labelDuplicate: "Duplicate name",
          labelTooLong: "The name for the AI is over 60 characters",
          whenToUseTooLong: "When to use is over 200 characters",
          queueMissing: "Queue no longer exists",
        },
      },
      // AI Configuration Wizard
      aiConfigurationWizard: {
        title: "Create AI Configuration",
        editTitle: "Edit AI Configuration",
        success: "Configuration created successfully!",
        updateSuccess: "Configuration updated successfully!",
        optional: "Optional",
        back: "Back",
        next: "Next",
        skip: "Skip",
        close: "Close",
        create: "Create Configuration",
        update: "Save Changes",
        saving: "Saving...",
        updating: "Updating...",
        steps: {
          basic: "Type",
          provider: "Provider",
          behavior: "Behavior",
          autonomous: "Autonomous",
          classifier: "Categories",
          integrations: "Integrations",
          review: "Review",
        },
        selectType: "Select the AI type",
        types: {
          assistant: {
            title: "Assistant",
            description: "Helps agents with response suggestions, summarization, and sentiment analysis.",
          },
          autonomous: {
            title: "Autonomous Mode",
            description: "Automatically responds to customers without human intervention, with configurable fallback.",
          },
          classifier: {
            title: "Classifier",
            description: "Classifies intents and automatically routes tickets to queues or agents.",
          },
        },
        configName: "Configuration Name",
        configNamePlaceholder: "E.g.: Technical Support, Sales, Main Classifier...",
        configNameHelper: "A descriptive name to identify this configuration",
        activeConfig: "Active Configuration",
        activeConfigHelper: "Disable to temporarily pause this AI",
        selectProvider: "Select Provider",
        selectModel: "Model",
        modelPlaceholder: "Select or type the model",
        apiKey: "API Key",
        apiKeyPlaceholder: "Paste your API Key here",
        apiKeyRequired: "Please enter the API Key",
        connectionSuccess: "Connection successful!",
        connectionFailed: "Connection failed",
        connectionError: "Error testing connection",
        testing: "Testing...",
        testConnection: "Test Connection",
        testConnectionHint: "We recommend testing the connection before continuing",
        advancedSettings: "Advanced Settings",
        customEndpoint: "Custom Endpoint (optional)",
        customEndpointHelper: "Use for proxies or alternative endpoints",
        systemPrompt: "System Prompt",
        systemPromptHelper: "Define the AI's personality and behavior",
        useTemplate: "Use template:",
        promptPlaceholder: "Type the instructions for the AI...",
        maxTokens: "Max Tokens",
        maxTokensTooltip: "Maximum token limit in the response",
        temperature: "Temperature",
        temperatureTooltip: "Controls the creativity of responses",
        features: "Additional Features",
        featuresHelper: "Enable extra features (optional)",
        feature: {
          enableSuggestions: "Suggestions",
          enableSummarization: "Summarization",
          enableTranslation: "Translation",
          enableTranscription: "Transcription",
        },
        autonomousMode: "Autonomous Mode",
        autonomousModeDescription: "AI responds automatically without human intervention",
        autonomousPrompt: "Complementary Instructions for Autonomous Mode",
        autonomousPromptHelper: "Additional instructions used only when the AI is attending alone. Complements the main prompt — does not replace it (optional)",
        autonomousPromptPlaceholder: "E.g.: When attending alone, be more direct and objective. Limit responses to 3 sentences...",
        autonomousPromptTip: "These instructions are added to the Main Prompt only when the AI is responding automatically (without a human).",
        autonomousDisabledInfo: "Autonomous mode is disabled. AI will only work as an assistant for agents.",
        classifierTitle: "Intent Categories",
        classifierDescription: "Configure categories to classify messages and route automatically",
        classifierTip: "Tip: Add relevant keywords to each category to improve classification accuracy. You can also link each category to a specific queue or specialized AI agent.",
        aiTools: "AI Tools (Function Calling)",
        aiToolsHelper: "Select the tools the AI can use to query external systems",
        noToolsAvailable: "No AI Tools available",
        createToolsHint: "Create AI Tools in the tools page",
        specificQueue: "Specific Queue (optional)",
        allQueues: "All queues",
        specificModels: "Specific Models by Feature",
        specificModelsHelper: "Configure different models for each feature (leave empty to use main model)",
        sentimentAnalysis: "Sentiment Analysis",
        voiceTTS: "Voice (Text-to-Speech)",
        reviewTitle: "All set!",
        reviewSubtitle: "Review the settings and click \"Create Configuration\"",
        basicInfo: "Basic Information",
        provider: "Provider",
        behavior: "Behavior",
        integrations: "Integrations",
        promptPreview: "System Prompt",
        quickTest: "Quick Test (Optional)",
        testPlaceholder: "Type a message to test the AI...",
        testOptional: "Testing is optional. You can create the configuration and test later.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      teams: {
        title: "Collaborative Teams",
        description: "Teams allow notifying all members when a teammate receives new messages. Teammates receive sound and visual alerts.",
        noTeams: "No teams created in this queue.",
        inactive: "Inactive",
        form: {
          addTitle: "New Team",
          editTitle: "Edit Team",
          name: "Team name",
          members: "Members",
          selectMembers: "Select members...",
        },
        buttons: {
          newTeam: "New Team",
          add: "Create",
          save: "Save",
          edit: "Edit",
          delete: "Delete",
          cancel: "Cancel",
        },
        toasts: {
          created: "Team created successfully!",
          updated: "Team updated successfully!",
          deleted: "Team deleted successfully!",
        },
        confirmDelete: {
          title: "Delete team",
          message: "Are you sure you want to delete this team? Members will stop receiving collaborative notifications.",
        },
        validation: {
          nameRequired: "Team name is required.",
          membersRequired: "Select at least one member for the team.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          queues: "Queues",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        tabs: {
          options: "Options",
          plans: "Plans",
          helps: "Help",
          myPlan: "My Plan",
        },
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          options: {
            updating: "Updating...",
            crossConnectionWarning: "Warn about service on another connection",
            crossConnectionWarningHelper:
              "Shows when the customer is already being served on another connection and notifies the original agent",
            crossConnectionLastAttendanceHours: "Show last service from another connection",
            crossConnectionLastAttendanceHoursHelper:
              "How long after closing the agent can see who served the customer on another connection and what was recorded",
            crossConnectionLastAttendanceOff: "Off",
          },
          waba: {
            title: "WhatsApp Business API (WABA)",
            description: "Configure the connection options via Official WhatsApp Business API",
            enableEmbeddedSignup: "Signup via Meta",
            enableWabaCoexistence: "Coexistence",
            qualityAlerts: "Quality Alerts",
            maxConnections: "WABA connections limit",
            maxConnectionsHelp: "Maximum WABA connections allowed for this company",
          },
        },
      },
      aiProviderHealth: {
        title: "AI paused — {{provider}} has no credit.",
        titleNoGate: "{{provider}} has no credit — AI keeps trying to send.",
        titleAwaiting: "{{provider}} has no credit — waiting for provider confirmation.",
        body: "{{count}} agent(s) affected: {{names}}. Top up the balance in the provider panel; the AI resumes on its own within {{minutes}} minute(s) after the top-up.",
        bodyNoAgents: "Top up the balance in the provider panel.",
        andMore: "and {{count}} more",
        openProviderPanel: "Open provider panel",
        viewAgents: "View agents",
        dismiss: "Dismiss",
        badge: "No credit",
        since: "since {{since}}",
      },
      aiKeyUsage: {
        tab: "Keys and usage",
        title: "AI keys and usage",
        refresh: "Refresh",
        retry: "Try again",
        loadError: "Could not load keys and usage.",
        rateLimited: "Too many requests in a short time. Wait a moment and try again.",
        providerHealthUnavailable: "Could not check provider credit right now.",
        updatedAt: "Updated at {{date}}",
        empty: "No AI configuration registered.",
        noWarnings: "No issues found.",
        fix: "Fix",
        sections: { warnings: "Warnings", features: "Features", keys: "Keys" },
        columns: {
          feature: "Feature",
          scope: "Scope",
          status: "Status",
          key: "Key",
          provider: "Provider",
          model: "Model",
          origin: "Origin",
          active: "Active",
          usedBy: "Used by",
          billing: "Credit"
        },
        scopeGlobal: "Global",
        scopeRemovedQueue: "Removed queue (#{{id}})",
        status: {
          ok: "OK",
          fallback: "Fallback key",
          missing: "No key",
          billing_blocked: "No credit",
          disabled: "Off",
          unknown: "Could not verify"
        },
        features: {
          agent_chat: "Agent (chat)",
          autonomous: "Autonomous AI",
          classifier: "Classifier",
          sentiment: "Sentiment",
          summarize: "Summary",
          suggestion: "Suggestion",
          transcription: "Transcription",
          tts: "Voice",
          translation: "Translation",
          language_detection: "Language detection",
          long_term_memory: "Long-term memory",
          jev: "Understanding (JEV)",
          legacy_prompt: "Legacy prompt"
        },
        slots: {
          apiKey: "main key",
          sentimentApiKey: "sentiment key",
          suggestionApiKey: "suggestion key",
          voiceApiKey: "voice key"
        },
        sources: { google_speech: "Google Speech", platform: "Platform key", none: "—" },
        key: {
          plaintext: "not encrypted",
          undecryptable: "cannot decrypt",
          noCreditUntil: "no credit until {{time}}"
        },
        keyWithQueue: "{{config}} (queue {{queue}})",
        yes: "Yes",
        no: "No",
        warnings: {
          feature_without_key: "{{feature}} is on, but there is no compatible key.",
          feature_without_key_queue: "{{feature}} is on in queue {{queue}}, but there is no compatible key.",
          undecryptable_key: "The {{slot}} of \"{{configuration}}\" cannot be read. Register the key again.",
          billing_blocked: "{{feature}} has no credit at provider {{provider}}.",
          fallback_key: "{{feature}} is using the {{slot}} from \"{{configuration}}\", not its own key.",
          plaintext_key: "The {{slot}} of \"{{configuration}}\" is stored without encryption. Register the key again to protect it.",
          plaintext_key_prompt: "The legacy prompt \"{{name}}\" stores its key unencrypted. Move the service to an AI configuration and unlink the prompt from the connection.",
          plaintext_key_prompt_fields: "The legacy prompt \"{{name}}\" stores these fields without encryption: {{fields}}. Move the service to an AI configuration and unlink the prompt from the connection.",
          plaintext_key_google: "The Google Speech credential is stored without encryption.",
          ambiguous_selection: "There is more than one possible configuration for {{feature}}; the system may use any of them.",
          diagnostic_error: "Could not verify {{feature}} right now. Try refreshing in a moment.",
          tts_other_queues: "Voice is only configured on some queues; tickets in the other queues get no voice."
        }
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            activateAI: "Activate AI",
            deactivateAI: "Deactivate AI",
            activateAIConfirm: "Activate AI with agent",
            activateAISuccess: "AI activated successfully!",
            deactivateAISuccess: "AI deactivated. Operator has resumed the conversation.",
            selectAgent: "Select AI Agent",
          },
        },
        errors: {
          sendFailed: "Message send failed",
          window24hExpired: "⏰ 24h window expired. Use an approved template to re-engage the customer.",
          rateLimit: "⚠️ Message limit reached. Wait a few minutes.",
          blocked: "🚫 This contact has blocked the number.",
          templateError: "📋 Template error",
          invalidNumber: "📵 Invalid number or not a WhatsApp number.",
        },
        deliveryErrors: {
          131026: "Not delivered — this number has no WhatsApp or cannot receive messages",
          131045: "Not sent — the connection's phone number must be registered again",
          131047: "24h window closed — use an approved template to resume the conversation",
          131049: "Meta limited marketing sends to this user — try again after 24h",
          131050: "This user opted out of marketing messages",
          130472: "Number is part of a Meta experiment — does not receive marketing",
          130497: "The account cannot message the country of this number",
          131021: "Cannot send to the connection's own number",
          131053: "Failed to upload the media",
          131056: "Too many messages to this number in a short time — wait",
          131031: "WhatsApp Business account restricted or disabled by Meta",
          131042: "Problem with the account's payment method",
          132000: "Template: parameter count does not match",
          132001: "Template does not exist or is not approved in this language",
          132005: "Template: translated text exceeds the limit",
          132007: "Template: content violates WhatsApp policy",
          132012: "Template: parameter in invalid format",
          132015: "Template paused by Meta for low quality",
          132016: "Template disabled by Meta for low quality",
          codeLabel: "code {{code}}",
          genericWithCode: "Not delivered (code {{code}}): {{metaText}}",
          genericCodeOnly: "Not delivered (code {{code}})",
          genericNoCode: "Not delivered: {{metaText}}",
        },
        renderError: "This message could not be displayed",
        mediaPending: {
          receiving: "Receiving {{kind}}…",
          unavailable: "Media unavailable",
          kinds: {
            image: "image",
            video: "video",
            audio: "audio",
            ptt: "audio",
            sticker: "sticker",
            document: "document",
            application: "document",
            media: "media",
          },
        },
        search: {
          tooOld: "Message too old to locate automatically. Scroll the history.",
          notFound: "Message not found in this conversation (it may have been deleted).",
          jumpToLatest: "Jump to latest messages",
          jumpToLatestCount: "Jump to latest messages ({{count}} new)",
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticket: {
        tasks: {
          title: "Tasks",
          empty: "No pending tasks linked to this ticket.",
          createNew: "New Task",
          addTask: "Add Task",
          pendingWarning: "This ticket has pending or in-progress tasks.",
          closeConfirmTitle: "There are pending tasks",
          closeConfirmMessage:
            "This ticket has pending or in-progress tasks. Do you want to close it anyway?",
          closeAnyway: "Close Anyway",
        },
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      profilePermissions: {
        title: "Access Permissions",
        description: "Define which menus supervisors and agents can view.",
        helper: "Adjust the selections and click 'Save changes'. The change is applied shortly for connected users.",
        propagation: "The change is applied shortly for connected users.",
        adminAlways: "Administrators always have full access",
        loading: "Loading permissions...",
        roles: {
          supervisor: "Supervisor",
          user: "Agent",
        },
        table: {
          menu: "Menu",
        },
        actions: {
          save: "Save changes",
          cancel: "Revert changes",
          saving: "Saving...",
          retry: "Try again",
          markAll: "Select all",
          unmarkAll: "Clear all",
          copyToUser: "Copy supervisor → agent",
          copyToSupervisor: "Copy agent → supervisor",
        },
        search: {
          label: "Search item",
          empty: "No items found",
        },
        error: {
          load: "Could not load permissions.",
        },
        unsaved: {
          label: "Unsaved changes",
          prompt: "There are unsaved permission changes. Leave anyway?",
        },
        copy: {
          title: "Copy permissions",
          body: "{{from}} selections replace {{to}} on this screen. Nothing is stored until you save.",
          confirm: "Copy",
          cancel: "Cancel",
        },
        aria: {
          item: "{{label}}, {{role}}",
          toggleAll: "{{action}}, {{role}}",
        },
        toasts: {
          updated: "Permissions updated. The change is applied shortly for connected users.",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
        transferLabel: "Select the connection that will receive the tickets",
        transferHelper:
          "Tickets will keep their current queues after the transfer.",
        transferUnavailable:
          "No other connection for this channel is available. Create a new one before deleting.",
        noTransferOption:
          "No other connection available for transfer. If there are tickets or contacts, they will be lost.",
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        edit: "Edit",
        forward: "Forward",
        talkTo: "Talk to",
        downloadAudio: "Download Audio",
        markSpam: "Mark as Spam",
        unmarkSpam: "Remove from Spam",
        spamMarked: "Marked as spam",
        spamToasts: {
          markedSynced: "Email marked as spam and synced with provider",
          unmarkedSynced: "Email removed from spam and synced with provider",
          markedLocal: "Email marked as spam locally (not synced with provider)",
          unmarkedLocal: "Email removed from spam locally (not synced with provider)",
        },
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_AI_FALLBACK_QUEUE_NOT_IN_COMPANY: "The fallback destination queue no longer exists in this company. Pick another queue under Fallback Actions.",
        ERR_AI_FALLBACK_USER_NOT_IN_COMPANY: "The supervisor configured for fallback does not belong to this company. Pick another user.",
        ERR_AI_FALLBACK_REF_INVALID: "Invalid fallback queue or user. Pick a value from the list.",
        ERR_INVALID_TRANSFER_TARGETS: "Invalid destination queues. Check that the queues exist and are not repeated.",
        ERR_TRANSFER_TOOL_RENAME: "The Transfer to queue tool cannot be renamed.",
        ERR_TEMPLATE_NAME_ALREADY_EXISTS: "A template with this name already exists.",
        ERR_NO_PERMISSION_DELETE_GROUP: "Only administrators can delete group tickets.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_CONTACT_IN_OTHER_WALLET:
          "This contact is assigned to another agent's wallet. Please ask an administrator for the transfer.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_CONTACT_NOT_FOUND: "Contact not found.",
        ERR_QUEUE_NOT_FOUND: "Queue not found.",
        ERR_INVALID_SLOT_VALUE:
          "Invalid appointment amount. Use a number greater than or equal to zero, with up to two decimal places (e.g. 150.00).",
        ERR_SLOT_CANCELLED: "This appointment has already been cancelled.",
        ERR_SLOT_ALREADY_CANCELLED: "This appointment was already cancelled.",
        ERR_SLOT_INVALID_STATE:
          "This appointment is not in a state that allows this action.",
        ERR_CONTACT_NUMBER_LOCKED_OPTOUT:
          "This contact asked not to receive messages. Only administrators can change the number.",
        ERR_CONSENT_REVERT_FORBIDDEN:
          "Only administrators can revert a consent opt-out.",
        ERR_CONSENT_REASON_REQUIRED:
          "Provide a reason (up to 200 characters) to revert the opt-out.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_GROUP_TRANSFER_TARGET_NO_ACCESS: "This agent does not have access to this group.",
        ERR_INVALID_GROUP_ACCESS: "Invalid group list. Reload the page and try again.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_NEWSLETTER_NOT_ADMIN: "This number is not an admin of the Channel.",
        ERR_CONNECTION_NEWSLETTER_ONLY: "This connection is in Channels-only mode.",
        ERR_GROUP_ADMIN_UNVERIFIED: "Could not confirm that this connection is a group admin. Try again in a moment.",
        ERR_GROUP_CHANNEL_NOT_SUPPORTED: "Groups are not available on this connection type.",
        ERR_GROUP_MANAGER_REQUIRED: "Only administrators and supervisors can perform this group action.",
        ERR_NEWSLETTER_DUPLICATE_PUBLISH: "This post was already sent. Wait and try again.",
        ERR_NEWSLETTER_OWNER_RISK_NOT_ACCEPTED:
          "Confirm that you understand the risk of this number owning the Channel.",
        ERR_NEWSLETTER_NAME_REQUIRED: "Enter the Channel name.",
        ERR_NEWSLETTER_NAME_TOO_LONG: "The Channel name can be at most 100 characters.",
        ERR_NEWSLETTER_DESCRIPTION_TOO_LONG: "The Channel description can be at most 2048 characters.",
        ERR_NEWSLETTER_DUPLICATE_CREATE: "This Channel is already being created. Wait and try again.",
        ERR_NEWSLETTER_CREATE_UNCONFIRMED:
          "Could not confirm whether the Channel was created. Click Refresh and check the list before trying again.",
        ERR_NEWSLETTER_EDIT_WINDOW_EXPIRED: "The time to edit this post has expired.",
        ERR_NEWSLETTER_MEDIA_TOO_LARGE: "The file is larger than 16 MB.",
        ERR_NEWSLETTER_MEDIA_TYPE: "Send an image or a video.",
        ERR_NEWSLETTER_PROVIDER_FAILURE: "WhatsApp did not confirm the post.",
        ERR_NEWSLETTER_MEDIA_UPLOAD_FAILED: "Failed to upload the Channel media.",
        ERR_NEWSLETTER_INVALID_JID: "Invalid Channel identifier.",
        ERR_NEWSLETTER_POST_NOT_FOUND: "Post not found.",
        ERR_NEWSLETTER_POST_NOT_PUBLISHED: "This post is not published.",
        ERR_NEWSLETTER_POST_BUSY: "This post is being changed. Try again in a moment.",
        ERR_NEWSLETTER_EDIT_TEXT_ONLY: "Only text posts can be edited.",
        ERR_NEWSLETTER_TEXT_REQUIRED: "Write the post text.",
        ERR_NEWSLETTER_TEXT_TOO_LONG: "The post text is too long.",
        ERR_NEWSLETTER_MEDIA_REQUIRED: "Send an image or a video.",
        ERR_NEWSLETTER_INVALID_TYPE: "Invalid post type.",
        ERR_NEWSLETTER_INVALID_REQUEST: "Could not publish with this data.",
        ERR_INVALID_WHATSMEOW_MODE: "Invalid connection mode.",
        ERR_WHATSMEOW_MODE_SAVE_FAILED: "Could not save the connection mode.",
        ERR_WHATSMEOW_MODE_UNSUPPORTED: "The WhatsApp service does not yet support Channels-only mode. Update the microservice.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_INVALID_DISTRIBUTION_STRATEGY: "Invalid distribution strategy.",
        ERR_INVALID_MAX_CONCURRENT_TICKETS:
          "The maximum simultaneous tickets must be an integer from 0 to 1000.",
        ERR_QUEUE_HAS_ACTIVE_TICKETS:
          "This queue can't be deleted: it has open or waiting tickets. Transfer them to another queue first.",
        ERR_QUEUE_IS_REDIRECT_TARGET:
          "This queue can't be deleted: it is the redirect (or Flow fallback) queue of a connection. Change the connection first.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_WAPP_PAUSED:
          "WhatsApp session is paused. Resume the connection to send messages.",
        ERR_TRANSFER_WHATSAPP_REQUIRED:
          "Select a destination connection to transfer tickets before deleting this one.",
        ERR_TRANSFER_WHATSAPP_INVALID_TARGET:
          "Invalid connection selected for transfer.",
        ERR_TRANSFER_WHATSAPP_TARGET_IN_REMOVAL:
          "The selected transfer connection is also scheduled for removal. Choose another.",
        ERR_TRANSFER_WHATSAPP_TARGET_NOT_FOUND:
          "Destination connection not found for this company.",
        ERR_TRANSFER_WHATSAPP_CHANNEL_MISMATCH:
          "Destination connection must belong to the same channel (WhatsApp, Facebook or Instagram).",
        ERR_TRANSFER_WHATSAPP_SAME_TARGET:
          "Please choose a different connection for transfer.",
        // Collaborative Teams errors
        ERR_TEAM_NAME_REQUIRED: "Team name is required.",
        ERR_TEAM_NAME_TOO_LONG: "Team name must be 100 characters or less.",
        ERR_TEAM_QUEUE_REQUIRED: "A queue is required to create a team.",
        ERR_TEAM_QUEUE_NOT_FOUND: "Queue not found or does not belong to this company.",
        ERR_TEAM_MEMBERS_REQUIRED: "Select at least one member for the team.",
        ERR_TEAM_USERS_NOT_IN_QUEUE: "Some selected members do not belong to this queue.",
        ERR_TEAM_NOT_FOUND: "Team not found.",
      },
      storageManagement: {
        title: "Storage Management",
        usage: "Disk Usage",
        quota: "Quota",
        noQuota: "Quota not configured",
        manage: "Storage",
        cancel: "Cancel",
        back: "Back",
        next: "Next",
        alerts: {
          warning: "Your storage is at {{percent}}%",
          critical: "Critical storage ({{percent}}%)",
          full: "Storage full!"
        },
        tabs: {
          olderThanDays: "Cleanup by Age",
          specificPeriod: "Cleanup by Period",
          dateRange: "Custom Range"
        },
        cleanup: {
          analyze: "Analyze",
          execute: "Clean Now",
          confirmation: "Type DELETE to confirm",
          started: "Cleanup started successfully!",
          completed: "{{count}} media deleted, {{size}} freed",
          deleteOlderThan: "Delete media older than X days",
          month: "Month",
          year: "Year",
          startDate: "Start Date",
          endDate: "End Date"
        },
        preview: {
          title: "Cleanup Preview",
          totalMessages: "Total Media",
          spaceToFree: "Space to Free",
          oldestDate: "Oldest Date",
          newestDate: "Newest Date",
          breakdown: "Breakdown by Type",
          breakdownDetails: "Details by media type:"
        },
        breakdown: {
          images: "Images",
          videos: "Videos",
          audios: "Audios",
          documents: "Documents",
          other: "Other"
        },
        confirm: {
          title: "Confirm Media Cleanup",
          step1: "Confirmation",
          step2: "Preview",
          step3: "Final Confirmation",
          step1Message: "Are you sure you want to delete these media? This action cannot be undone.",
          step3Message: "To confirm the deletion, type DELETE in the field below:",
          invalidWord: "Incorrect word. Type 'DELETE' to confirm.",
          confirmDelete: "Confirm Deletion",
          executing: "Deleting media...",
          recentlyDeleted: "Recently deleted files"
        },
        errors: {
          invalidCriteria: "Invalid criteria. Please check the filled fields.",
          noPreview: "Error: Preview not found. Please analyze again.",
          minioNotEnabled: "Media cleanup is only available when MinIO is enabled."
        },
        history: {
          title: "Cleanup History",
          empty: "No cleanup performed yet.",
          date: "Date",
          executedBy: "Executed by",
          deletedFiles: "Files",
          freedSpace: "Space",
          duration: "Duration",
          status: "Status",
          rowsPerPage: "Items per page:",
          criteria: "Criteria used"
        }
      },
      myPlan: {
        title: "My Plan",
        subtitle: "Your current plan and available features",
        noPlan: "No plan found",
        contactSupport: "Contact support to check your plan.",
        limits: {
          title: "Plan Limits",
          users: "Users",
          connections: "Connections",
          queues: "Queues/Departments",
          unlimited: "∞"
        },
        features: {
          title: "Enabled Features",
          disabledTitle: "Not Included Features",
          whatsapp: "WhatsApp (Wuzapi)",
          waba: "WhatsApp Business API",
          webchat: "Webchat",
          facebook: "Facebook Messenger",
          instagram: "Instagram Direct",
          telegram: "Telegram",
          campaigns: "Campaigns",
          schedules: "Schedules",
          callbacks: "Callbacks",
          kanban: "Kanban",
          openai: "Talk.AI",
          integrations: "Integrations",
          externalApi: "External API",
          internalChat: "Internal Chat",
          ifood: "iFood",
          sipPhone: "SIP Phone",
          email: "Email",
          googleCalendar: "Google Calendar"
        },
        footer: "To change your plan or add features, contact support.",
        contactWhatsApp: "Chat on WhatsApp",
        whatsappMessage: "Hello! I would like to know more about the available plans and features."
      },

      // ========================================
      // TASKS - Task Management
      // ========================================
      tasks: {
        title: "Tasks",
        newTask: "New Task",
        editTask: "Edit Task",
        viewTask: "Task Details",
        deleteConfirm: "Delete task",
        deleteMessage: "Are you sure you want to delete this task?",
        
        // Popover
        popover: {
          title: "My Tasks",
          tabs: {
            tasks: "Tasks",
            notifications: "Activity",
            announcements: "Announcements",
          },
          pending: "pending",
          inProgress: "in progress",
          viewAll: "View all tasks",
          emptyTasks: "No pending tasks! 🎉",
          emptyNotifications: "No pending notifications",
          approval: {
            title: "Approval Requested",
            someone: "Someone",
            wantsToChange: "wants to change",
            from: "from",
            to: "to",
            approve: "Approve",
            reject: "Reject",
            approved: "Status change approved!",
            rejected: "Status change rejected",
            error: "Error processing approval",
          },
        },
        
        status: {
          pending: "Pending",
          in_progress: "In Progress",
          completed: "Completed",
          cancelled: "Cancelled",
        },
        
        priority: {
          high: "High",
          medium: "Medium",
          low: "Low",
        },
        
        fields: {
          title: "Title",
          description: "Description",
          priority: "Priority",
          status: "Status",
          dueDate: "Due Date",
          participants: "Participants",
          contact: "Linked Contact",
          createdBy: "Created by",
          createdAt: "Created at",
          completedAt: "Completed at",
        },
        
        alerts: {
          title: "Configured Alerts",
          firstAlert: "Alert (days before)",
          secondAlert: "Alert (hours/min)",
          none: "None",
          daysBefore: "{{count}} day before",
          daysBefore_plural: "{{count}} days before",
          hoursBefore: "{{count}} hour before",
          hoursBefore_plural: "{{count}} hours before",
          minutesBefore: "{{count}} minutes before",
        },
        
        attachments: {
          title: "Attachments",
          upload: "Attach",
          uploading: "Uploading...",
          download: "Download",
          delete: "Delete",
          preview: "Preview",
          empty: "No attachments. Click \"Attach\" to add.",
          deleteConfirm: "Delete attachment \"{{filename}}\"?",
          uploadSuccess: "Attachment uploaded successfully!",
          uploadError: "Error uploading attachment",
          downloadError: "Error downloading attachment",
          deleteError: "Error deleting attachment",
          deleteSuccess: "Attachment deleted",
          invalidType: "File type not allowed. Use images, videos or PDFs.",
          tooLarge: "File too large. Maximum is 50MB.",
          previewTitle: "Preview Attachment",
          close: "Close",
          noPreviewAvailable: "Preview not available for this file type",
          previewError: "Error loading preview",
        },
        
        observations: {
          title: "Observations",
          placeholder: "Write an observation... Use @ to mention",
          empty: "No observations yet.",
          reply: "Reply",
          edit: "Edit",
          delete: "Delete",
          edited: "edited",
          deleteConfirm: "Delete this observation?",
        },
        
        logs: {
          title: "History",
          actions: {
            created: "Task created",
            updated: "Task updated",
            completed: "Task completed",
            cancelled: "Task cancelled",
            reopened: "Task reopened",
            status_changed: "Status changed",
            participant_added: "Participant added",
            participant_removed: "Participant removed",
            attachment_added: "Attachment added",
            attachment_removed: "Attachment removed",
            observation_added: "Observation added",
          },
        },
        
        buttons: {
          save: "Save",
          cancel: "Cancel",
          close: "Close",
          edit: "Edit Task",
          history: "History",
          refresh: "Refresh",
        },
        
        messages: {
          loadError: "Error loading tasks",
          saveSuccess: "Task saved successfully!",
          saveError: "Error saving task",
          deleteSuccess: "Task deleted successfully!",
          deleteError: "Error deleting task",
          titleRequired: "Title is required",
        },
        
        ticketMedia: {
          title: "Ticket Media",
          preview: "Preview Media",
          noPreview: "Preview not available for this file type",
          imageAlt: "Ticket media",
        },
        
        kanban: {
          emptyColumn: "No tasks",
          dragHint: "Drag to move",
          laneEditor: {
            wipLimit: "Ticket limit (WIP)",
            wipLimitHelp: "Maximum number of simultaneous tickets in this column. Leave empty for no limit.",
          },
          truncation: {
            message: "Showing {shown} of {total} tickets. Reduce the period to see all.",
          },
          groupBy: {
            label: "Group by",
            none: "None",
            user: "Agent",
            queue: "Queue",
            source: "Source",
          },
          aging: {
            recent: "Recent",
            daysInStage: "{days}d in this stage",
          },
          search: {
            placeholder: "Search tickets...",
            noResults: "No tickets found",
          },
          keyboard: {
            title: "Keyboard Shortcuts",
            refresh: "Refresh data",
            fullscreen: "Toggle fullscreen",
            help: "Open help guide",
            escape: "Exit fullscreen",
            column: "Scroll to column N",
          },
        },
      },
      // Unified Automations
      automations: {
        title: "Automations",
        buttons: {
          add: "New Automation",
          refresh: "Refresh",
          clearFilters: "Clear Filters",
        },
        table: {
          status: "Status",
          name: "Name",
          trigger: "Trigger",
          actions: "Actions",
          executions: "Executions",
          lastExecution: "Last Execution",
          options: "Options",
        },
        triggers: {
          ticket_created: "Ticket Created",
          funnel_entry: "Funnel Entry",
          funnel_move: "Stage Change",
          time_in_stage: "Time in Stage",
          inactivity: "Inactivity",
          score_changed: "Score Changed",
          value_set: "Value Set",
          message_received: "Message Received",
          ticket_closed: "Ticket Closed",
          // Phase 1-3
          user_assigned: "User Assigned",
          queue_changed: "Queue Changed",
          first_response: "First Response",
          contact_returned: "Contact Returned",
          keyword_detected: "Keyword Detected",
          sla_warning: "SLA Warning",
          sla_breached: "SLA Breached",
          media_received: "Media Received",
          ticket_transferred: "Ticket Transferred",
          birthday_today: "Birthday Today",
          business_hours_start: "Business Hours Start",
          business_hours_end: "Business Hours End",
          contact_created: "Contact Created",
          contact_field_updated: "Contact Field Updated",
          webhook_received: "Webhook Received",
          // AI Automation Integration
          ai_handoff_triggered: "AI Handoff",
          ai_response_generated: "AI Response Generated",
          // Phase B - AI triggers
          ai_sentiment_detected: "AI Sentiment Detected",
          ai_intent_classified: "AI Intent Classified",
          ai_tool_executed: "AI Tool Executed",
          ai_turn_limit_approaching: "Turn Limit Approaching",
          // Phase C - General triggers
          tag_added: "Tag Added",
          tag_removed: "Tag Removed",
          ticket_reopened: "Ticket Reopened",
          nps_received: "NPS Received",
          outside_business_hours: "Outside Business Hours",
        },
        // AI Automation Integration - Actions
        aiActions: {
          activate_autonomous_mode: "Activate Autonomous Mode",
          aiConfigurationId: "AI Agent",
          maxTurnsOverride: "Turns Limit (Override)",
          customContextPrompt: "Additional Context",
          fallbackActionOverride: "Fallback Action (Override)",
          sendInitialMessage: "Send Initial Message",
          initialMessage: "Initial Message",
          maxActivationDepth: "Maximum Depth",
        },
        // Phase B/C - New action configs
        actionConfigs: {
          ai_summarize_ticket: "Summarize Ticket with AI",
          ai_classify_intent: "Classify Intent with AI",
          ai_analyze_sentiment: "Analyze Sentiment with AI",
          ai_generate_voice: "Generate Voice with AI",
          ai_smart_route: "AI Smart Routing",
          ai_handoff_summary: "Generate Handoff Briefing",
          ai_pause_autonomous: "Pause Autonomous Mode",
          add_internal_note: "Add Internal Note",
          send_reaction: "Send Reaction (Emoji)",
          transfer_ticket: "Transfer Ticket",
          mark_as_resolved: "Mark as Resolved",
          summaryFormat: "Summary Format",
          summaryFormatOptions: {
            brief: "Brief",
            detailed: "Detailed",
            bullet: "Bullet Points",
          },
          includeActionItems: "Include action items",
          includeSentiment: "Include sentiment",
          saveAsNote: "Save as note on ticket",
          minConfidence: "Minimum Confidence",
          autoRoute: "Auto-route based on intent",
          saveAsTag: "Save intent as tag",
          escalateOnNegative: "Escalate on negative sentiment",
          escalateQueueId: "Escalation Queue",
          notifySupervisor: "Notify supervisor",
          text: "Text to generate audio",
          textPlaceholder: "Hello {{contact.name}}, your ticket #{{ticket.id}}...",
          provider: "Voice Provider",
          voiceId: "Voice ID",
          allowQueueChange: "Allow queue change",
          allowAgentChange: "Allow agent change",
          notifyOnRoute: "Notify on routing",
          attachToTicket: "Attach briefing to ticket",
          includeStepsTaken: "Include steps taken",
          includeSuggestedActions: "Include suggested actions",
          notifyAgent: "Notify agent",
          notifyOnPause: "Notify on pause",
          noteContent: "Note Content",
          noteContentPlaceholder: "Use {{contact.name}} and {{ticket.id}} as variables",
          emoji: "Emoji",
          emojiPlaceholder: "👍",
          targetType: "Transfer Type",
          targetTypeOptions: {
            queue: "Queue",
            user: "Agent",
          },
          targetQueueId: "Target Queue",
          targetUserId: "Target Agent",
          keepCurrentUser: "Keep current agent on queue",
          addNote: "Add resolution note",
          noteMessage: "Note Message",
          noteMessagePlaceholder: "Ticket resolved by automation.",
        },
        // AI Automation Integration - Trigger configs
        aiTriggers: {
          handoffReasons: "Handoff Reasons",
          aiConfigurationIds: "AI Agents",
          fallbackActions: "Fallback Actions",
          confidenceThreshold: "Confidence Range",
          turnCountThreshold: "After N Turns",
          handoffReasonsOptions: {
            low_confidence: "Low Confidence",
            turn_limit: "Turn Limit",
            customer_request: "Customer Requested Human",
            customer_satisfied: "Customer Satisfied",
            error: "Error",
            timeout: "Timeout",
          },
          fallbackActionsOptions: {
            notify_supervisor: "Notify Supervisor",
            transfer_queue: "Transfer to Queue",
            notify_owner: "Notify Owner",
            pause_bot: "Pause Bot",
            close_ticket: "Close Ticket",
          },
        },
        modal: {
          createTitle: "New Automation",
          editTitle: "Edit Automation",
          save: "Save",
          cancel: "Cancel",
          sections: {
            basicInfo: "Basic Info",
            trigger: "Trigger (When to execute)",
            actions: "Actions (What to do)",
            preview: "Flow Preview",
          },
          fields: {
            name: "Automation Name",
            description: "Description",
            priority: "Priority",
            active: "Active",
            triggerType: "Trigger Type",
            stageId: "Stage ID",
            delayMinutes: "Delay (minutes)",
          },
        },
        confirmDelete: {
          title: "Delete Automation",
          message: "Are you sure you want to delete the automation \"{{name}}\"? This action cannot be undone.",
        },
        logs: {
          title: "Execution Logs",
          empty: "No logs found",
          columns: {
            date: "Date",
            action: "Action",
            status: "Status",
            time: "Time",
            error: "Error",
          },
          status: {
            success: "Success",
            error: "Error",
            skipped: "Skipped",
          },
        },
        empty: {
          title: "No automations found",
          description: "Create your first automation to get started",
        },
        toasts: {
          created: "Automation created successfully",
          updated: "Automation updated successfully",
          deleted: "Automation deleted successfully",
          activated: "Automation activated",
          deactivated: "Automation deactivated",
          duplicated: "Automation duplicated",
          error: "Error processing automation",
        },
      },
      // Customer Journey
      journey: {
        title: "Customer Journey",
        filters: {
          startDate: "Start Date",
          endDate: "End Date",
        },
        summary: {
          totalLeads: "Total Leads",
          inFunnel: "In Funnel",
          conversion: "Conversion",
          totalValue: "Total Value",
        },
        tabs: {
          overview: "Overview",
          bySource: "By Source",
          campaigns: "Campaigns",
        },
        charts: {
          funnel: "Sales Funnel",
          conversionBySource: "Conversion by Source",
          forecast: "Revenue Forecast",
          campaignROI: "Campaign ROI",
        },
        sources: {
          organic: "Organic",
          campaign: "Campaign",
          waba_flow: "WhatsApp Flow",
          meta_flow: "Meta Flow",
          webchat: "Webchat",
          telegram: "Telegram",
          facebook: "Facebook",
          instagram: "Instagram",
          voip: "VoIP",
          import: "Import",
        },
        forecast: {
          title: "Revenue Forecast",
          expectedDeals: "expected deals",
          byStage: "By Stage (probability weighted)",
        },
        empty: {
          noData: "No data available",
          loading: "Loading...",
        },
      },

      // ========================================
      // VOICE API SETTINGS
      // ========================================
      voiceApiSettings: {
        title: "Voice AI Integration",
        description: "Configure the integration between FusionPBX and OmniPlay",
        status: {
          active: "Active",
          inactive: "Inactive",
          generating: "Generating...",
          revoking: "Revoking...",
        },
        token: {
          label: "API Token",
          labelNew: "API Token (COPY NOW!)",
          masked: "voice_••••••••••••••••",
          helperExisting: "Existing token. Generate a new one if you need the full value.",
          copied: "Token copied to clipboard!",
          copyWarning: "Generate a new token to copy.",
        },
        buttons: {
          generate: "Generate API Token",
          generateNew: "Generate New Token",
          revoke: "Revoke Token",
          refresh: "Refresh",
        },
        alerts: {
          copyNow: "⚠️ ATTENTION: Copy the token now! For security, it will not be displayed again.",
          noToken: "No token configured. Generate a token to enable the integration.",
          revokeConfirm: "Are you sure you want to revoke the token? The FusionPBX integration will be disabled.",
          keepSecret: "The token must be kept secret. Anyone with access to the token can query your company's queues and users.",
        },
        info: {
          title: "What is Voice AI Integration?",
          description: "Allows FusionPBX (your phone system) to connect to OmniPlay to:",
          features: {
            queues: "Automatically fetch queues to route voice tickets",
            users: "List available users for callback",
            tickets: "Create tickets from phone calls",
          },
        },
        instructions: {
          title: "How to Configure in FusionPBX",
          step1: "Access FusionPBX → Voice Secretary → 🔗 OmniPlay",
          step2: "Paste the API URL and the Token generated above",
          step3: "Click \"Test Connection\" to verify",
          step4: "Click \"Force Sync\" to load queues and users",
          apiUrl: "API URL:",
        },
        apiReference: {
          title: "API Reference",
          description: "Available endpoints for external systems:",
          ping: "Tests the connection and returns company ID",
          queues: "Lists all company queues",
          users: "Lists all company users (optional: ?queueId=X)",
          company: "Returns company info (queue/user count, timezone)",
        },
        expiresAt: "Expires at:",
        errors: {
          load: "Error loading token info",
          generate: "Error generating token",
          revoke: "Error revoking token",
        },
        success: {
          generate: "Token generated successfully!",
          revoke: "Token revoked successfully",
        },
      },
      // Embedded Signup - WABA Self-Service
      embeddedSignup: {
        connectWithMeta: "Connect via Meta Business",
        connectWithCoexistence: "Connect with Coexistence",
        connected: "Successfully Connected",
        description: "Connect your WhatsApp Business account in a few clicks - no need to copy tokens manually",
        descriptionShort: "Connect in a few clicks - no need to copy tokens",
        orManual: "or configure manually below",
        // Accordion Labels
        recommended: "Recommended",
        advanced: "Advanced",
        manualConfig: "Manual Configuration",
        manualConfigDescription: "IDs and tokens from Facebook Developer Console",
        webhookConfig: "Webhook Configuration",
        webhookConfigDescription: "Configure to receive messages",
        integrationStatus: "Integration Status",
        integrationStatusDescription: "Validation and connection test",
        loadingConfig: "Loading configuration...",
        loadingSDK: "Loading Facebook SDK...",
        processing: "Processing registration...",
        success: "WhatsApp Business API connection created successfully!",
        cancelled: "Registration cancelled",
        cancelledMessage: "Registration was cancelled. Click to try again.",
        successMessage: "Your WhatsApp Business API account has been successfully connected!",
        reviewPending: "Note: Your account is under review by Meta. This may take up to 72 hours.",
        tryAgain: "Try Again",
        connectionLimitReached: "Plan limit of {{max}} connections reached ({{current}}/{{max}}). Contact support to increase your limit.",
        featureDisabled: "Embedded Signup is not enabled for your company. Please contact support.",
        coexistenceDisabled: "Coexistence mode is not enabled for your company.",
        step: "Step",
        of: "of",
        // Coexistence
        coexistenceOption: "Keep WhatsApp Business App active (Coexistence)",
        coexistenceTooltip: "Click to learn more about coexistence mode",
        coexistenceTitle: "What is Coexistence?",
        coexistenceDescription: "Allows you to use the WhatsApp Business App and official API at the same time on the same number.",
        coexistenceBenefit1: "Continue using the app on your phone",
        coexistenceBenefit2: "Receive messages on both channels",
        coexistenceBenefit3: "Import up to 6 months of history",
        coexistenceLimitations: "Limitations: Groups don't sync, some app features are disabled.",
        // Steps
        steps: {
          facebook_login: "Facebook Login",
          select_waba: "Select Account",
          select_phone: "Select Number",
          verify_phone: "Verify Number",
          register: "Register",
          sync_templates: "Sync Templates",
          complete: "Complete"
        },
        // Steps Descriptions
        stepsDescription: {
          facebook_login: "Log in with your Facebook account to authorize access.",
          select_waba: "Select or create your WhatsApp Business account.",
          select_phone: "Choose the phone number to be connected.",
          verify_phone: "Verify the number with the code sent via SMS or call.",
          register: "Registering the number with WhatsApp Business API.",
          sync_templates: "Syncing existing message templates.",
          complete: "Registration complete! Your connection is ready to use."
        },
        // Progress
        progress: "Registration Progress",
        coexistenceMode: "Coexistence Mode",
        coexistenceNote: "Coexistence mode: you can use both WhatsApp Business App and API simultaneously.",
        // Errors
        errors: {
          loadConfigFailed: "Error loading configuration. Please try again.",
          sdkLoadFailed: "Error loading Facebook SDK. Check your connection.",
          noAppId: "Facebook App configuration not found.",
          notAuthorized: "You did not authorize access. Please try again.",
          startFailed: "Error starting registration. Please try again.",
          processingFailed: "Error processing registration. Please try again.",
          unknown: "An unknown error occurred."
        }
      },
      // Campaigns
      campaigns: {
        title: "Campaigns",
        recurrence: {
          title: "Recurring Campaign",
          type: "Frequency",
          monthly: "Monthly",
          weekly: "Weekly",
          daily: "Daily",
          dayOfMonth: "Day of month",
          dayOfWeek: "Day of week",
          sunday: "Sunday",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          time: "Time",
          timezone: "Timezone",
          startDate: "Start date",
          endDate: "End date (last send)",
          nextExecutions: "Next executions",
          advanced: "Advanced options",
          skipWeekends: "Skip weekends (postpone to Monday)",
          skipHolidays: "Skip holidays",
          notifyOnExecution: "Notify after each execution",
          notifyEmail: "Notification email",
          status: {
            active: "Active",
            paused: "Paused",
            completed: "Completed",
            cancelled: "Cancelled",
          },
          history: {
            title: "Execution History",
            execution: "Execution",
            date: "Date",
            status: "Status",
            sent: "Sent",
            failed: "Failed",
            skipped: "Skipped",
            duration: "Duration",
          },
        },
        variables: {
          title: "Variable Mapping",
          description: "Configure which contact list data will be used to fill template variables.",
          selectTemplate: "Select a template to configure variables",
          column: "Column",
          notMapped: "Not mapped",
          default: "Default value",
          skipMissing: "Skip contacts with empty required variables",
          allMapped: "All variables configured",
          someMissing: "Some variables are not mapped",
          preview: "Message preview",
          noPreview: "Configure mapping to see preview",
        },
      },
      // Quality Rating
      wabaQuality: {
        limit: "Limit",
        green: {
          title: "Quality Rating: Good",
          label: "Good",
          description: "Your account is in good standing. Keep up the good messaging practices."
        },
        yellow: {
          title: "Quality Rating: Warning",
          label: "Warning",
          description: "Your account is on alert. Improve your message quality to avoid restrictions."
        },
        red: {
          title: "Quality Rating: Critical",
          label: "Critical",
          description: "Your account is in critical state. Message limits may be reduced. Review your practices immediately."
        },
        unknown: {
          title: "Quality Rating: Unknown",
          label: "N/A",
          description: "Quality rating has not been determined for this account yet."
        }
      },
      // Coexistence Status
      wabaCoexistence: {
        title: "Coexistence Mode",
        active: "Coexistence Active",
        migrated: "Migrated",
        activeDescription: "WhatsApp Business App and API are running simultaneously on this number.",
        migratedDescription: "This number was migrated from Business App to API.",
        offboarded: "Reconnecting",
        offboardedDescription:
          "The number was disconnected from the API because the customer switched devices or re-registered on the WhatsApp Business App. Sending is paused while Meta reconnects, which usually takes a few minutes. If this warning persists, the reconnection did not complete and the connection needs to be checked.",
        offboardedSince: "Disconnected since {{since}}."
      },
      // Review Status
      wabaReview: {
        pending: "Pending",
        inProgress: "Under Review",
        rejected: "Rejected",
        flagged: "Flagged",
        pending_description: "Your account is awaiting Meta review.",
        review_in_progress_description: "Meta is reviewing your account. This may take up to 72 hours.",
        rejected_description: "Your account was rejected by Meta. Check the developer console for details.",
        flagged_description: "Your account has been flagged for additional review."
      },
      // OAuth Callback - Meta redirect page
      oauthCallback: {
        // Titles
        loadingTitle: "Processing...",
        successTitle: "Authorization Complete!",
        errorTitle: "Authorization Error",
        cancelledTitle: "Authorization Cancelled",
        // Messages
        processing: "Please wait while we process your authorization...",
        success: "Authorization completed successfully! You can return to the app.",
        successRedirect: "Authorization complete! Click the button to continue.",
        error: "An error occurred during authorization. Please try again.",
        cancelled: "You cancelled the authorization process.",
        noCode: "No authorization code received. Please try again.",
        storageError: "Error saving data. Please try again.",
        // Actions
        closeWindow: "Close Window",
        goToConnections: "Go to Connections",
        orRedirect: "or",
        closingIn: "This window will close in {{seconds}} seconds..."
      },
      pauseModal: {
        title: "Pause Mode",
        subtitle: "Select the duration of your break",
        confirm: "Activate Pause",
        cancel: "Cancel",
        options: {
          quick: {
            label: "15 min",
            description: "Quick break",
          },
          coffee: {
            label: "30 min",
            description: "Coffee / break",
          },
          lunch: {
            label: "1h30",
            description: "Lunch",
          },
          manual: {
            label: "Manual",
            description: "Set the time",
          },
        },
        customTime: {
          title: "Set the duration",
          hours: "hours",
          minutes: "minutes",
          totalLabel: "Total",
          selectDuration: "Select the duration",
        },
      },
      calendarSelector: {
        all: "All",
        institutional: "Institutional",
        personal: "Personal",
        loading: "Loading calendars...",
        error: "Error loading calendars",
        label: "Calendar",
        placeholder: "Select a calendar",
      },
      calendar: {
        slot: {
          ticketLabel: "Ticket (optional)",
          ticketNone: "None",
          ticketLoadError: "Could not load tickets",
          queueFromTicket: "The queue comes from the ticket",
          noQueue: "No queue",
          ticketOption: "#{{id}} · {{status}} · {{queue}} · {{date}}",
          statuses: {
            open: "Open",
            pending: "Pending",
            closed: "Closed",
            lgpd: "LGPD",
            chatbot: "Chatbot",
            group: "Group",
            nps: "Rating",
          },
        },
        reassign: {
          title: "Reassign Scheduling",
          targetUser: "Target user",
          targetQueue: "Target queue",
          selectQueue: "Select a queue",
          reason: "Reason (optional)",
          reasonPlaceholder: "E.g.: Team transfer",
          submit: "Reassign",
          cancel: "Cancel",
          processing: "Reassigning...",
          success: "Scheduling reassigned successfully!",
          selectUserAndQueue: "Select the target user and queue",
        },
      },
      calendarManagement: {
        title: "Manage Calendars",
        subtitle: "Personal calendars for attendants and queue subcalendars",
        institutionalSection: "Company Calendar",
        personalSection: "Personal Calendars",
        subCalendarSection: "Provision Subcalendar",
        noInstitutional: "No institutional calendar connected.",
        noPersonal: "No personal calendars connected yet.",
        connectPersonal: "Connect personal calendar for:",
        disconnect: "Disconnect calendar",
        removeSubCalendar: "Remove subcalendar",
        selectUser: "Attendant",
        selectQueue: "Queue / Specialty",
        provision: "Create Subcalendar",
        close: "Close",
      },
      stalledTickets: {
        title: "Stalled conversations",
        subtitle: "Customers who sent the last message and have not been answered yet",
        tabs: { open: "In progress", pending: "Waiting" },
        filters: { user: "Agent", queue: "Queue", whatsapp: "Connection", all: "All", minWait: "Waiting longer than", userPending: "Waiting has no agent" },
        settings: {
          title: "Alert thresholds",
          warn: "Attention from (min)",
          danger: "Critical from (min)",
          invalid: "Attention must be lower than critical",
          save: "Save",
        },
        level: { normal: "Within range", warning: "Attention", danger: "Critical" },
        summary: { noQueue: "No queue", tickets: "stalled", maxWait: "longest wait" },
        timeline: {
          titleOpen: "Who is holding the queue",
          titlePending: "Where customers are waiting",
          hint: "Each dot is a customer waiting. Click a row to filter.",
          legendOk: "up to {{time}}",
          legendWarn: "{{from}} to {{to}}",
          legendDanger: "more than {{time}}",
          maxWait: "longest wait",
          waitingFor: "Waiting for {{time}}",
          ariaLane: "{{name}}: {{count}} stalled, longest wait {{time}}",
        },
        table: {
          contact: "Contact",
          user: "Agent",
          queue: "Queue",
          whatsapp: "Connection",
          waiting: "Waiting for",
          lastMessage: "Customer's last message",
          actions: "Actions",
          noUser: "No agent",
          noWhatsapp: "No connection",
          since: "Since",
          openTicket: "Open ticket #{{id}} of {{name}}",
        },
        empty: "No customer waiting for a reply for more than {{time}}",
        emptyFiltered: "No customer in this filter waiting for a reply for more than {{time}}",
        clearFilters: "Clear filters",
        truncated: "More than 2000 stalled customers in this tab. Showing those who have been waiting the longest; use the filters to narrow it down.",
        error: "Could not load stalled conversations",
        staleError: "Could not refresh. The list below may be out of date.",
        retry: "Try again",
        refresh: "Refresh",
        loading: "Loading stalled conversations",
        updatedNow: "Updated just now",
        updatedAgo: "Updated {{time}} ago",
        pageLabel: "Page {{page}}",
        openPending: {
          title: "Open ticket without an owner",
          message: "Opening marks the messages as read and the customer gets a read receipt. Continue?",
          confirm: "Open",
        },
        actions: {
          menu: "Actions",
          menuFor: "Actions for ticket #{{id}} of {{name}}",
          preview: "Preview",
          transfer: "Transfer",
          assume: "Take over",
          assuming: "Taking over...",
          nudge: "Remind agent",
          assumeTitle: "Take over conversation",
          assumeMessage: "You will become responsible for {{name}}'s conversation. Continue?",
          assumeSuccess: "Ticket taken over",
          transferSuccess: "Ticket transferred",
          nudgeTitle: "Remind agent",
          nudgeLabel: "Message via internal chat",
          nudgeTo: "To: {{name}} · waiting {{time}}",
          nudgeSend: "Send",
          nudgeSending: "Sending...",
          nudgeSuccess: "Reminder sent to {{name}}",
        },
        nudgeTemplate:
          "Hi, {{attendantName}}. Customer {{contactName}} has been waiting for a reply for {{waitingText}} on ticket #{{ticketId}}.",
        media: {
          image: "Image",
          video: "Video",
          audio: "Audio",
          document: "Document",
          sticker: "Sticker",
          location: "Location",
          vcard: "Contact",
          file: "File",
        },
        prevPage: "Previous page",
        nextPage: "Next page",
      },
      moments: {
        title: "Real-Time Service Panel",
        empty: {
          title: "No tickets found",
          subtitle: "Tickets will appear here when available",
          noResults: "No results for selected filters",
        },
        toolbar: {
          filters: "Filters",
          groupByUser: "Group by agent",
          groupByQueue: "Group by queue",
          compactMode: "Compact mode",
          alerts: "Sound alerts",
          help: "Help",
          refresh: "Refresh data",
          fullscreen: "Fullscreen",
          exitFullscreen: "Exit fullscreen (ESC)",
          collapseOffline: "Collapse offline",
        },
        filters: {
          search: "Search contact or ticket...",
          clear: "Clear filters",
          queue: "Filter by queue",
          status: "Filter by status",
          connection: "Filter by connection",
        },
        status: {
          online: "Online",
          paused: "Paused",
          offline: "Offline",
          pending: "Pending",
        },
        column: {
          noTickets: "No tickets",
          avgResponseTime: "Average response time",
          avgFirstResponse: "Average first response time",
          avgQueueTime: "Average queue time",
          urgentTooltip: "waiting for response for more than 30 minutes",
          capacity: "Capacity",
          collapse: "Collapse",
          expand: "Expand",
        },
        ticket: {
          view: "View ticket",
          queue: "Queue",
          noQueue: "NO QUEUE",
          connection: "Connection",
          noConnection: "NO CONNECTION",
          waitingSince: "Waiting for response for",
        },
        contextMenu: {
          open: "Open ticket",
          transfer: "Transfer ticket",
          assume: "Assume ticket",
          close: "Close ticket",
        },
        actions: {
          transferSuccess: "Ticket transferred successfully",
          assumeSuccess: "Ticket assumed successfully",
          closeSuccess: "Ticket closed successfully",
        },
        confirmClose: {
          title: "Close ticket",
          message: "Are you sure you want to close this ticket? This action cannot be undone.",
          cancel: "Cancel",
          confirm: "Close",
        },
        preview: {
          title: "Recent messages",
          empty: "No messages found",
          openFull: "Open full conversation",
        },
        alerts: {
          title: "Configure Sound Alerts",
          enable: "Enable sound alerts",
          waitThreshold: "Alert when ticket waits for",
          pendingThreshold: "Alert when pending tickets reach",
          close: "Close",
        },
        help: {
          title: "Help - Service Panel",
          statusColors: "Header Colors",
          green: "Green",
          greenDesc: "Agent online and available",
          yellow: "Yellow",
          yellowDesc: "Agent on break (lunch/rest)",
          red: "Red",
          redDesc: "Agent offline (not logged in)",
          gray: "Gray",
          grayDesc: "Pending tickets (no agent assigned)",
          interactionTitle: "Ticket Interaction",
          dragDrop: "Drag tickets between columns to transfer (supervisors/admins only)",
          rightClick: "Right-click on a ticket for quick actions (transfer, assume, close)",
          hoverPreview: "Hover over a ticket to preview the latest messages",
          toolbarTitle: "Toolbar",
          filterDesc: "Use filters to search by name/ID, filter by agent status (online, paused, offline) or by queue",
          groupByDesc: "Switch between grouping by agent (individual view) or by queue/department (departmental view)",
          compactDesc: "Enable compact mode to see more tickets per column — shows only name, time and badges in a single line",
          collapseDesc: "Click the arrow in the column header to collapse it. Click again to expand. State is saved automatically",
          metricsTitle: "Metrics & Indicators",
          capacityDesc: "The colored bar in the header indicates capacity: green (light), yellow (moderate), red (overloaded)",
          timerDesc: "Tickets awaiting response show a live timer with a red border. After 30 min, the card pulses",
          urgentBadge: "The red badge with a number indicates urgent tickets waiting for over 30 minutes",
          alertsTitle: "Sound Alerts",
          alertsDesc: "Configure alerts to be notified when tickets wait too long or when there are too many pending in the queue",
          fullscreenDesc: "Use fullscreen mode for an expanded view. Press ESC to exit",
        },
      },
      ifood: {
        connectionModal: {
          defaultQueue: "Orders queue",
          defaultQueueHelp:
            "New orders enter this queue. Without a queue, only users with 'View tickets without a queue' can see them.",
        },
      },
      whatsappGroups: {
        hook: {
          participantsPartialFailure: "{{count}} participant(s) could not be updated: {{list}}",
        },
      },
    }
  },
};

export { messages };
